import { Outlet } from 'react-router-dom';
import Header from '../components/Header';
import MMHeader from '../components/MMHeader';
import Footer from '../components/Footer';
import Maintenance from '../components/Maintenance';
import { useState, useEffect } from 'react';
import useAxiosPrivate from '../hooks/useAxiosPrivate';
import { useNavigate, useLocation } from "react-router-dom";
import useAuth from '../hooks/useAuth';
import { ToastContainer, toast } from 'react-toastify';


const Layout = () => {

	const [loading, setLoading] = useState(false);
	const axiosPrivate = useAxiosPrivate();
	const navigate = useNavigate();
	const location = useLocation();

	const [data, setData] = useState()

	const [maintenanceMode, setMaintenanceMode]= useState(true)
	const [notifications, setNotifications] = useState()
	const [passName, setPassName] = useState(process.env.REACT_APP_PASS_NAME)

	const [error, setError] = useState()

	const auth = useAuth();

	useEffect(() => {
		const controller = new AbortController();
		setLoading(true);
		const getData = async () => {
			try {
				const response = await axiosPrivate.get('data/pass/' + process.env.REACT_APP_PASS, {
					signal: controller.signal
				});
				setMaintenanceMode(response.data.pass_data.maintenance.maintenance_mode_enabled)
				setData(response.data)
				setNotifications(response.data.pass_data.notifications)
				setLoading(false)
			} catch(err) {
				setError(err.message)
				console.log(err.message);
				!auth && navigate('/login', { state: { from: location }, replace: true });
			}
		}

		getData();

		return () => controller.abort();
		// eslint-disable-next-line
	}, [])

	const refreshData = async () => {
		const controller = new AbortController();
		setLoading(true);
		const dismiss = () =>  toast.dismiss(updateToast.current);
		const updateToast = toast.loading("Updating Conditions");

		try {
			const response = await axiosPrivate.get('data/pass/' + process.env.REACT_APP_PASS, {
				signal: controller.signal
			});
			setMaintenanceMode(response.data.pass_data.maintenance.maintenance_mode_enabled)
			setData(response.data)
			setNotifications(response.data.pass_data.notifications)
			setLoading(false)
			toast.update(updateToast, { render: 'Conditions Updated', type: 'success', isLoading: false, autoClose: 5000});

		} catch(err) {
			setError(err.message)
			console.log(err.message);
			toast.update(updateToast, { render: 'Failed to update condition', type: 'error', isLoading: false, autoClose: 5000});

			!auth && navigate('/login', { state: { from: location }, replace: true });
		}
		return () => controller.abort();

	}

	return (
		<main className="App">
			{maintenanceMode ?
				<>
					<MMHeader />
					<Maintenance loading={loading} passName={passName}/>
					<Footer />
				</>
			:
				<>
					<Header notifications={notifications} data={data} setData={setData} refreshData={refreshData} loading={loading} />
					<Outlet context={[data, setData]} />
					<Footer />
				</>
			}

			<ToastContainer
			position="top-right"
			autoClose={5000}
			hideProgressBar={false}
			newestOnTop={false}
			closeOnClick
			rtl={false}
			pauseOnFocusLoss
			draggable
			pauseOnHover
			theme="colored"
			/>

		</main>
	)
}

export default Layout